import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TooltipOptions } from "primereact/tooltip/tooltipoptions";
import { localeShortDateTime } from "../../../../app/datetimeUtils";
import { scoreReportEssayLink } from "../../../../app/links";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { PromptUsage } from "./promptReportApiSlice";

export function EssayPromptScoreTable(props: { className: string; scores: PromptUsage[] }) {
	const tooltipOptions: TooltipOptions = {
		position: "top",
		showDelay: 250,
		hideDelay: 0,
	};

	const dateTimeTemplate = (rowData: PromptUsage) => {
		return (
			<Link className="link" to={scoreReportEssayLink(rowData.essayId)}>
				{localeShortDateTime(rowData.lastUsedDate)}
			</Link>
		);
	};
	return (
		<DataTable
			value={props.scores}
			dataKey="essayId"
			loading={props.scores == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}>
			<Column
				header="Most Recent Submission"
				body={dateTimeTemplate}
				sortable
				sortField="date"></Column>
			<Column header="Prompt" field="promptName" sortable></Column>
			<Column header="Drafts" field="draftCount" sortable></Column>
			<Column
				header="Dev"
				field="developmentOfIdeas"
				className="!px-2"
				headerTooltip="Development of Ideas"
				headerTooltipOptions={tooltipOptions}
				headerClassName="!px-2 min-w-12"></Column>
			<Column
				header="Org"
				field="organization"
				className="!px-2"
				headerTooltip="Organization"
				headerTooltipOptions={tooltipOptions}
				headerClassName="!px-2 min-w-12"></Column>
			<Column
				header="Style"
				field="style"
				className="!px-2"
				headerTooltip="Style"
				headerTooltipOptions={tooltipOptions}
				headerClassName="!px-2 min-w-12"></Column>
			<Column
				header="WC"
				field="wordChoice"
				className="!px-2"
				headerTooltip="Word Choice"
				headerTooltipOptions={tooltipOptions}
				headerClassName="!px-2 min-w-12"></Column>
			<Column
				header="Sent"
				field="sentenceStructure"
				className="!px-2"
				headerTooltip="Sentence Structure"
				headerTooltipOptions={tooltipOptions}
				headerClassName="!px-2 min-w-12"></Column>
			<Column
				header="Conv"
				field="conventions"
				className="!px-2"
				headerTooltip="Conventions"
				headerTooltipOptions={tooltipOptions}
				headerClassName="!px-2 min-w-12"></Column>
			<Column
				header="Total"
				field="totalScore"
				className="!px-2"
				sortable
				headerTooltip="Total Score"
				headerTooltipOptions={tooltipOptions}
				headerClassName="!px-2 min-w-12"></Column>
		</DataTable>
	);
}
